exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-expression .formula:empty:before{content:attr(placeholder);-webkit-text-fill-color:var(--fts-default)}.fts-expression .formula fts-i-unit{background-color:#c8f0ff;padding:3px;margin:1px;cursor:pointer}.fts-expression .information-unit-select{margin:3px}.fts-expression .editor-expression{margin-top:10px;margin-bottom:10px;font-size:.675rem;color:var(--fts-default)}", ""]);

// exports
